

































import { Vue, Component } from "vue-property-decorator";

export default class VerificationCancelled extends Vue {}
